import filesize from "filesize"
import { get } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { Button, Table } from "semantic-ui-react"

const ContextsTable = ({ availableFields, contexts, onDeleteContext, onEditContext }) => (
	<Table celled definition>
		<Table.Header>
			<Table.Row>
				<Table.HeaderCell />
				<Table.HeaderCell>Id</Table.HeaderCell>
				<Table.HeaderCell>Nazwa</Table.HeaderCell>
				<Table.HeaderCell>Rozmiar załączników</Table.HeaderCell>
				<Table.HeaderCell>Dostępne pola</Table.HeaderCell>
				<Table.HeaderCell>Sp Id</Table.HeaderCell>
				<Table.HeaderCell>Hasło</Table.HeaderCell>
			</Table.Row>
		</Table.Header>
		<Table.Body>
			{contexts.map(context => (
				<Table.Row key={context.id}>
					<Table.Cell collapsing>
						<Button.Group size="small">
							<Button
								attached="left"
								onClick={() => onEditContext(context)}
								primary
								icon="edit"
							/>
							<Button
								attached="right"
								onClick={() => onDeleteContext(context)}
								secondary
								icon="trash"
							/>
						</Button.Group>
					</Table.Cell>
					<Table.Cell>{get(context, "id")}</Table.Cell>
					<Table.Cell>{get(context, "name")}</Table.Cell>
					<Table.Cell>{filesize(get(context, "fileSize", 0))}</Table.Cell>
					<Table.Cell>
						{get(context, "availableFields", []).map((fieldName, index) => (
							<div key={index}>
								{get(
									availableFields.find(({ name }) => name === fieldName),
									"desc"
								)}
							</div>
						))}
					</Table.Cell>
					<Table.Cell>{get(context, "spId")}</Table.Cell>
					<Table.Cell>{get(context, "password")}</Table.Cell>
				</Table.Row>
			))}
		</Table.Body>
	</Table>
)

ContextsTable.propTypes = {
	availableFields: PropTypes.array,
	contexts: PropTypes.array,
	onDeleteContext: PropTypes.func.isRequired,
	onEditContext: PropTypes.func.isRequired
}

ContextsTable.defaultProps = {
	availableFields: [],
	contexts: []
}

export default ContextsTable



// WEBPACK FOOTER //
// ./src/containers/contexts/components/ContextsTable.js